import { colors } from "@app/theme/colors"
import { chakra, LinkBox, Text } from "@chakra-ui/react"

export const FoldedPage = chakra(LinkBox, {
  baseStyle: {
    w: ["284px", "315px"],
    h: "180px",
    pos: "relative",
    textAlign: "left",
    px: 2,
    py: 2,
    pr: 4,
    bg: "brand.beige.dark",

    ":before": {
      content: '""',
      pos: "absolute",
      top: 0,
      right: 0,
      borderWidth: "0 40px 40px 0",
      borderStyle: "solid",
      borderColor: `${colors.neutral} white`,
    },
  },
})

export const Description = chakra(Text, {
  baseStyle: {
    d: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
  },
})
